import { MD5, enc } from 'crypto-js';

export const colorInterpolate = (index, length, hexStart, hexEnd) => {
  const ratio = length > 1 ? index / (length - 1) : 1; // Handle case where length is 1
  const adjustedRatio = Math.max(ratio, 0.001); // Ensure ratio is never exactly 0
  // Parse the initial and final colors from hex to integer components
  // const startColor = { r: 0x1d, g: 0x2c, b: 0x3f }; // Dark blue #1d2c3f
  // const endColor = { r: 0xa1, g: 0x2a, b: 0x31 }; // Reddish #a12a31

  const startColor = {
    r: parseInt(hexStart.slice(1, 3), 16),
    g: parseInt(hexStart.slice(3, 5), 16),
    b: parseInt(hexStart.slice(5, 7), 16),
  };
  const endColor = {
    r: parseInt(hexEnd.slice(1, 3), 16),
    g: parseInt(hexEnd.slice(3, 5), 16),
    b: parseInt(hexEnd.slice(5, 7), 16),
  };

  // Linear interpolation for each color component
  const red = Math.round(startColor.r + (endColor.r - startColor.r) * adjustedRatio);
  const green = Math.round(startColor.g + (endColor.g - startColor.g) * adjustedRatio);
  const blue = Math.round(startColor.b + (endColor.b - startColor.b) * adjustedRatio);

  return `rgb(${red}, ${green}, ${blue})`;
};

const nameToNumber = (name) => {
  const hash = MD5(name).toString(enc.Hex);
  return parseInt(hash.slice(0, 9), 16);
};

// Fonction pour interpoler une couleur entre deux couleurs hexadécimales
const interpolateColor = (ratio, hexStart, hexEnd) => {
  const adjustedRatio = Math.max(ratio, 0.001);
  const startColor = {
    r: parseInt(hexStart.slice(1, 3), 16),
    g: parseInt(hexStart.slice(3, 5), 16),
    b: parseInt(hexStart.slice(5, 7), 16),
  };

  const endColor = {
    r: parseInt(hexEnd.slice(1, 3), 16),
    g: parseInt(hexEnd.slice(3, 5), 16),
    b: parseInt(hexEnd.slice(5, 7), 16),
  };

  const red = Math.round(startColor.r + (endColor.r - startColor.r) * adjustedRatio);
  const green = Math.round(startColor.g + (endColor.g - startColor.g) * adjustedRatio);
  const blue = Math.round(startColor.b + (endColor.b - startColor.b) * adjustedRatio);

  return `rgb(${red}, ${green}, ${blue})`;
};

// Fonction principale pour générer des couleurs à partir des noms
export const colorInterpolateFromNames = (name, hexStart, hexEnd) => {
  const maxNumberValue = 0xffffff;
  const nameValue = nameToNumber(name);
  const ratio = (nameValue % maxNumberValue) / maxNumberValue;
  return interpolateColor(ratio, hexStart, hexEnd);
};

export const getTextColor = (backgroundColor) => {
  const rgb = backgroundColor.match(/\d+/g).map(Number);
  // Calculate luminance
  const luminance = 0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]; // Y = 0.299 R + 0.587 G + 0.114 B
  return luminance > 128 ? 'black' : 'white';
};
